export default __webpack_public_path__ + "static/media/ILPlatform_Robot.4ae81869.webp";